export const conversionFactors = {
  length: {
    mm: {
      English: 0.0393701,
      Metric: 1,
    },
    inch: {
      English: 1,
      Metric: 25.4,
    },
  },
  weight: {
    gram: {
      English: 0.00220462,
      Metric: 1,
    },
    pound: {
      English: 1,
      Metric: 453.592,
    },
  },
};
